function toDecimal2(value) {
  return Math.round(value * 100) / 100;
}

function toDecimal4(value) {
  return Math.round(value * 10000) / 10000;
}

function toDecimal6(value) {
  return Math.round(value * 1000000) / 1000000;
}

function toDecimal10(value) {
  return Math.round(value * 10000000000) / 10000000000;
}

export { toDecimal2, toDecimal4, toDecimal6, toDecimal10 };
